import { OperationSystemEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/operating-system.enum";

/** Plataformas soportadas en este módulo: solo Android y Windows */
export const SUPPORTED_PLATFORMS = [
  OperationSystemEnum.ANDROID,
  OperationSystemEnum.WINDOWS,
] as const;

export const OPERATING_SYSTEM_LABELS: Partial<Record<OperationSystemEnum, string>> = {
  [OperationSystemEnum.ANDROID]: "Android",
  [OperationSystemEnum.WINDOWS]: "Windows",
};

export const OPERATING_SYSTEM_STORES: Partial<Record<OperationSystemEnum, string>> = {
  [OperationSystemEnum.ANDROID]: "Apk File",
  [OperationSystemEnum.WINDOWS]: "Desktop Client",
};

export const OPERATING_SYSTEM_ICONS: Partial<Record<OperationSystemEnum, string>> = {
  [OperationSystemEnum.ANDROID]: "android",
  [OperationSystemEnum.WINDOWS]: "desktop_windows",
};

export const OPERATING_SYSTEM_OPTIONS = SUPPORTED_PLATFORMS.map((value) => ({
  value,
  label: OPERATING_SYSTEM_LABELS[value] ?? value,
}));

export const PLATFORM_CARDS_ORDER: readonly OperationSystemEnum[] = SUPPORTED_PLATFORMS;
